import { PreviewCart } from "../cart/preview-cart";
import { ProductVariants } from "../product/product-variants";
import { GeneralOverlay } from "../general/general-overlay";

class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const quickAddElements = this.querySelectorAll(".product-card__quick-add");
        quickAddElements.forEach((element: any) => {
            element?.addEventListener("click", this.openQuickAddPanel.bind(this));
        })

        const addToCartButton = this.querySelector(".product__cta-button");
        addToCartButton?.addEventListener("click", this.onAddToCartClick.bind(this));

        this.addEventListener("mouseleave", this.closeQuickAddPanel.bind(this));

        const productVariantInputs = this.querySelectorAll("product-variants input");
        const productVariants = new ProductVariants();
        productVariantInputs.forEach((input) => {
            const variantId = input.getAttribute("data-id") as string;

            input.addEventListener("change", () => {
                productVariants.onVariantSelect(variantId, this)
            })
        })
    }

    openQuickAddPanel(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const quickAddPanelEle = this.querySelector('.product-card__quick-add-panel');
        quickAddPanelEle?.classList.add('open');

        const target = event.currentTarget as HTMLElement;
        const isMobile = target.classList.contains("mobile");
        const template = document.querySelector("body")?.getAttribute("data-template");

        if(isMobile && template == "collection") {
            const generalOverlay = new GeneralOverlay();
            generalOverlay.applyOverlay(quickAddPanelEle);
        }
    }

    closeQuickAddPanel() {
        const quickAddPanelEle =  this.querySelector('.product-card__quick-add-panel');
        quickAddPanelEle?.classList.remove('open');

        // const screenWidth = window.innerWidth;

        // if (screenWidth <= 750) {
        //     const generalOverlay = new GeneralOverlay();
        //     generalOverlay.removeOverlay(quickAddPanelEle);
        // }       
    }

    onAddToCartClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.closeQuickAddPanel();
        const variantInput = this.querySelector('product-variants input[type="radio"]:checked') as HTMLInputElement;
        const itemKey = variantInput.value;
        const quantityInput = this.querySelector('product-quantity input[type="number"]') as HTMLInputElement;
        const quantity = Number(quantityInput.value);

        const previewCart = new PreviewCart();

        previewCart.addItem(itemKey, quantity)
        .then((data: any) => {
            if (data.status && data.status >= 400) {
                previewCart.closePreviewCart();
                this.querySelectorAll(".product-form__error-message-wrapper").forEach((ele: any) => {
                    previewCart.cartErrorHandling(ele, data.description);
                })

                const quickAddElement = this.querySelector(".product-card__quick-add.mobile") as HTMLElement;
                quickAddElement.click();
            }
            else {
                previewCart.refreshPreviewCart(data);
            }
        })
        .catch((error) => {
            console.error("error", error)
        })
    }
}

customElements.define("product-card", ProductCard);

